<select class="form-select" [(ngModel)]="model" id="numselect" name="numselect" (ngModelChange)="eventChange()">
  <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
</select>